type DevSectionAttr = { "data-cc-section": string };

/** Dev-only section marker for the inspo inspector. Stripped in production builds. */
export function devSectionAttr(sectionKey: string): DevSectionAttr | Record<string, never> {
  if (process.env.NODE_ENV === "production") {
    return {};
  }

  return { "data-cc-section": sectionKey };
}
